import React, { useContext, useEffect } from 'react';

import cookie from 'react-cookies';
import { useLocation, useNavigate } from 'react-router-dom';

import './Home.css';

import Layout from '../components/common/Layout';
import { UserContext } from '../context/UserContext';

const OAuthLink = () => {
  const { appData } = useContext(UserContext);
  const location = useLocation();
  const oauth_state_id = new URLSearchParams(location.search).get('oauth_state_id');

  useEffect(() => {
    if (appData && appData.id) {
      cookie.save(`oauth_state_id`, oauth_state_id, { path: '/' });
      cookie.save(`receivedRedirectUri`, window.location.href, { path: '/' });
      window.location.href = `/product/${appData.loanProductId}/application/${appData.id}`;
    }
  }, [appData]);

  return (
    <Layout>
      <div className="loading"></div>
    </Layout>
  );
};
export default OAuthLink;
